module.exports = __webpack_public_path__ + "static/react-82a318ccea22a8af9fc4590f41df9238.png";